module.exports = __webpack_public_path__ + "img/img_7.673bca85.png";